import { useMutation, useQueryClient } from '@tanstack/react-query';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';

import { getEdgeConfigurationsQueryKey } from 'hooks/queries/omni/useListEdgeConfigurationsQuery';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

type UseSetEdgeConfigurationAsDefaultMutationProps = {
  clusterId: string;
  edgeLocationId: string;
  edgeConfigurationId: string;
};

export const useSetEdgeConfigurationAsDefaultMutation = () => {
  const queryClient = useQueryClient();
  const { currentOrganization } = useOrganizations();

  return useMutation({
    mutationFn: async ({
      clusterId,
      edgeLocationId,
      edgeConfigurationId,
    }: UseSetEdgeConfigurationAsDefaultMutationProps) => {
      return apiClient.omni.updateEdgeConfiguration({
        organizationId: currentOrganization!.id,
        clusterId,
        edgeLocationId,
        id: edgeConfigurationId,
        edgeConfigurationUpdate: { default: true },
        updateMask: 'default',
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getEdgeConfigurationsQueryKey({}),
      });
      notify.success(
        'Edge configuration has been set as default successfully!'
      );
    },
    onError: (error: unknown) => {
      notify.error(parseApiError(error));
    },
  });
};
